package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_26_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn uses necromancy to return the animating spirit to Obraxus’s corpse, and the heroes interrogate him. Obraxus was sent by Meridus Pent of Pentish (Dorvidia) to obtain the Shield of Concar, but Obraxus considered Meridus Pent an enemy.  Obraxus used stored spells to battle the heroes.  The heroes aren’t familiar with Meridus Pent, but they know that Pentish is a city on the west coast of the Dorvidian Empire. They heard that Lord Pent of Pentish was in league with the demon Graz’zt; however, they don’t know Lord Pent’s forename. The heroes bury the body and move on.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Near the end of the day, the heroes notice that the path has become less rough and more swampy, and they notice less wildlife. Korvis thinks they are close to Seshiss.")
    }
}
